import { CheckCircle2, Settings2 } from 'lucide-react'

import { DiscordIcon } from '@/components/icons/BrandIcons'
import { MOCK_SQUADRON } from '@/features/marketing/mockData/squadron'

/**
 * Discord bot card mockup. Shows the connected state with the guild
 * name + a few example bot affordances (announce events, sync roles).
 */
export function DiscordCardMockup() {
  const sq = MOCK_SQUADRON
  return (
    <div className="p-6">
      <div className="flex items-start gap-4">
        <div
          className="flex size-12 shrink-0 items-center justify-center rounded-xl"
          style={{ backgroundColor: '#5865F2' }}
        >
          <DiscordIcon className="size-7 text-white" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            <h3 className="font-display text-base font-bold text-fg">
              Discord
            </h3>
            <span className="font-display inline-flex items-center gap-1 rounded-md border border-success/30 bg-success/10 px-1.5 py-0.5 text-[10px] font-bold tracking-[0.15em] text-success uppercase">
              <CheckCircle2 className="size-2.5" aria-hidden />
              Connected
            </span>
          </div>
          <p className="mt-1 text-xs text-fg-muted">
            #{sq.discordGuildName}
          </p>
        </div>
        <button
          type="button"
          className="rounded-md border border-border bg-bg/40 p-1.5 text-fg-subtle"
          aria-label="Settings"
        >
          <Settings2 className="size-3.5" aria-hidden />
        </button>
      </div>

      <div className="mt-5 space-y-2">
        {[
          { label: 'Announce new events to #ops-channel', enabled: true },
          { label: 'Sync squadron roles to Discord roles', enabled: true },
          { label: 'Post tournament results', enabled: true },
          { label: 'Daily check-in reminder', enabled: false },
        ].map((r) => (
          <div
            key={r.label}
            className="flex items-center justify-between rounded-md border border-border/60 bg-bg/40 px-3 py-2"
          >
            <span className="text-xs text-fg">{r.label}</span>
            <span
              className={`relative inline-flex h-4 w-7 rounded-full ${r.enabled ? 'bg-primary' : 'bg-border'}`}
              aria-hidden
            >
              <span
                className={`absolute top-0.5 size-3 rounded-full bg-white transition-all ${r.enabled ? 'right-0.5' : 'left-0.5'}`}
              />
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
